import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';




@Component({
  selector: 'app-casting',
  templateUrl: './casting.component.html',
  styleUrls: ['./casting.component.css'],
})
export class CastingComponent implements OnInit {
  movieId: any;
  stageName: any;
  castingDetails: any;
  data: any;
  stageContentDTOs: any[] = [];
  playVideo = false;
  admin = false;
  public video: any;
  movieName: any;
  userId: any;
  stagesOfData: any;
  movieDesc: any;
  movieBannerImg: any;
  contestId: any;
  contests: Object;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private hitmakerService: HitmakerService,
    public auth: AuthenticationService,
    public sanitizer: DomSanitizer,
    private adminApi: AdminService,
    private service: FilmServiceService
  ) {}

  ngOnInit(): void {
    this.movieId = this.activatedRoute.snapshot.params['id'];

    this.getMovieDetails();

    this.hitmakerService
      .getContestAssociated(this.movieId, 'CASTING')
      .subscribe((res) => {
        this.contests = res;
        this.contestId = this.contests[0]?.associatedContestId;
        console.log(this.contests);
        console.log(this.contestId);
      });
    this.adminApi.getCreaticsHomepage().subscribe((data) => {
      this.userId = data.userId;
    });
    this.auth.checkUserAuthenticated().subscribe((data: any) => {
      var role = data.adminRole;
      if (!role) {
        this.admin = false;
      } else {
        this.admin = true;
      }
    });
    this.stageName = 'casting';
    this.hitmakerStageDetails();
  }

  hitmakerStageDetails() {
    this.hitmakerService
      .getHitmakerStageDetails(this.movieId, 'CASTING')
      .subscribe((response) => {
        this.castingDetails = response;
        if(!this.castingDetails.showThumbnail && !this.admin){
          alert("Stay tuned for more updates!");
          this.router.navigate(['/hitmaker/' + this.movieId]);
        }
        this.data = JSON.stringify(this.castingDetails);
        this.stageContentDTOs =
          this.castingDetails?.stageContent[0]?.stageContentDTOs;
        if (!this.admin) {
          this.stageContentDTOs = this.stageContentDTOs?.filter(
            (details) => !details.hidden
          );
        }
      });
   
  }

  uploadDetails() {
    this.router.navigate([
      '/hitmaker/' + this.movieId + '/stage/' + this.stageName + '/upload',
    ]);
  }

  playVideo1(details: any) {
    this.playVideo = true;
    this.video = this.sanitizer.bypassSecurityTrustResourceUrl(details);
  }

  closeVideo() {
    this.video = '';
    this.playVideo = false;
  }

  deleteStageMovie(stageId: any) {
    if (confirm('Permanently delete the content?')) {
      this.hitmakerService.deleteStageContent(stageId).subscribe(() => {
        this.hitmakerStageDetails();
      });
    } else {
    }
  }

  hideStageContent(details: any) {
    if (
      confirm(
        'Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)'
      )
    ) {
      this.hitmakerService.hideStageContent(details.id, true).subscribe(() => {
        details.hidden = true;
        this.hitmakerStageDetails();
      });
    } else {
    }
  }

  showStageContent(stageId: any) {
    if (
      confirm(
        'Toggle the public visibility of the content? (Note - Hidden content will only be visible to the producers of this movie or Creatics admins)'
      )
    ) {
      this.hitmakerService.hideStageContent(stageId, false).subscribe(() => {
        this.hitmakerStageDetails();
      });
    } else {
    }
  }

  updateShowContent(details: any) {
    this.router.navigate([
      '/hitmaker/' +
        this.movieId +
        '/stage/' +
        this.stageName +
        '/update/' +
        details.id,
    ]);
  }
  upvoteContent(details: any) {
    this.hitmakerService
      .getUserUpvoteBalnce()
      .subscribe((balanceResponse: any) => {
        const userBalance = balanceResponse - 1;

        if (userBalance >= 0) {
          this.hitmakerService.upvoteStageContent(details.id).subscribe(
            (response) => {
              if (response) {
                alert(
                  `Congratulations, you got 5 currency points! Your free Jewel balance for today is ${userBalance}`
                );
                this.hitmakerStageDetails();
              }
            },
            (error) => {
              alert('Episode already jewels!');
            }
          );
        } else {
          alert('You have already used up your 10 free jewels for today.');
        }
      });
  }
  getMovieDetails() {
    this.adminApi.getHitmakerMoviePage(this.movieId).subscribe((data) => {
      this.movieName = data.movieName;

      console.log(this.movieName);
    });
  }
  onFanCastIt() {
    this.hitmakerService
      .getContestAssociated(this.movieId, 'CASTING')
      .subscribe((res) => {
        console.log(res);

        this.contests = res;
        this.contestId = this.contests;
        console.log(this.contestId.associatedContestId);
        let contestId =this.contestId.associatedContestId;
        if(contestId == 0){
        alert("'FANS CAST IT' contest for this movie is coming soon. Stay tuned!");
        }
        else{
          this.router.navigate(['/contest/' + contestId]);

        }
        return res;
      });
  }
}